/**
 * Schema Quejas / Sugerencias LABSYSO (F-PGC-6-1 entrada + F-PGC-6-2 seguimiento).
 */

export const QUEJA_TIPOS = {
  QUEJA: "queja",
  SUGERENCIA: "sugerencia",
};

export const QUEJA_ESTADOS = [
  { id: "recibida", label: "Recibida" },
  { id: "registrada", label: "Registrada" },
  { id: "en_analisis", label: "En análisis" },
  { id: "procede", label: "Procede" },
  { id: "no_procede", label: "No procede" },
  { id: "comunicada", label: "Comunicada" },
  { id: "en_seguimiento", label: "En seguimiento" },
  { id: "cerrada", label: "Cerrada" },
  { id: "escalada_pgc7", label: "Escalada PGC-7" },
];

export const QUEJA_ESTADO_IDS = QUEJA_ESTADOS.map((e) => e.id);

export const QUEJA_ORIGEN = {
  WEB_LABSYSO: "web_labsyso",
  MANUAL: "manual",
};

export function createEmptyQueja(overrides = {}) {
  return {
    tipoSolicitud: QUEJA_TIPOS.QUEJA,
    nombreCompleto: "",
    email: "",
    telefono: "",
    relacion: "",
    relacionOtro: "",
    fechaIncidente: "",
    horaIncidente: "",
    personasAfectadas: "",
    areaServicio: "",
    areaServicioOtro: "",
    descripcion: "",
    quejaAnterior: "",
    fechaQuejaAnterior: "",
    gestionAnterior: "",
    formCode: "F-PGC-6-1, edición 3",
    source: QUEJA_ORIGEN.MANUAL,
    folio: "",
    codigoInterno: "",
    estado: "recibida",
    fechaRecepcion: "",
    fechaAcuse: "",
    acuseEnviado: false,
    procede: null,
    analisisResumen: "",
    solucionInmediata: "",
    fechaLimiteAnalisis: "",
    comunicacionCliente: "",
    fechaComunicacion: "",
    accionesCorrectivas: "",
    evaluacionEfectividad: "",
    fechaCierre: "",
    cerradoPor: "",
    asignadoA: "",
    asignadoEmail: "",
    notasInternas: [],
    ...overrides,
  };
}

/** Cuenta días hábiles (lun–vie) entre dos fechas ISO/Date. */
export function businessDaysBetween(from, to = new Date()) {
  const start = from instanceof Date ? new Date(from) : new Date(from);
  const end = to instanceof Date ? new Date(to) : new Date(to);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 0;
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  let days = 0;
  const cur = new Date(start);
  while (cur < end) {
    cur.setDate(cur.getDate() + 1);
    const wd = cur.getDay();
    if (wd !== 0 && wd !== 6) days += 1;
  }
  return days;
}

export function isAnalisisOverdue(queja, limitDays = 5) {
  const open = ["recibida", "registrada", "en_analisis"].includes(queja?.estado);
  if (!open) return false;
  const created = queja?.createdAt?.toDate?.()
    ? queja.createdAt.toDate()
    : queja?.fechaRecepcion
      ? new Date(queja.fechaRecepcion)
      : null;
  if (!created) return false;
  return businessDaysBetween(created) > limitDays;
}

export function estadoLabel(id) {
  return QUEJA_ESTADOS.find((e) => e.id === id)?.label || id || "—";
}
